import request from '@/utils/request';
/* 列表 */
export function queryGiveawayPageList(data) {
  return request({
    url: '/giveaway/queryGiveawayPageList',
    method: 'POST',
    data
  });
}
/* 删除赠品 */
export function removeGiveawayById(data) {
  return request({
    url: '/giveaway/removeGiveawayById',
    method: 'POST',
    data
  });
}
/* 上架或下架赠品活动 */
export function enableGiveawayById(data) {
  return request({
    url: '/giveaway/enableGiveawayById',
    method: 'POST',
    data
  });
}
/* 获取所有上架的商品列表 */
export function queryAllEnableGoodsList(data) {
  return request({
    url: '/giveaway/queryAllEnableGoodsList',
    method: 'POST',
    data
  });
}
/* 新增赠品-活动 */
export function saveGiveaway(data) {
  return request({
    url: '/giveaway/saveGiveaway',
    method: 'POST',
    data
  });
}
/* 修改赠品-活动 */
export function updateGiveaway(data) {
  return request({
    url: '/giveaway/updateGiveaway',
    method: 'POST',
    data
  });
}
/* 活动明细-活动 */
export function fetchGiveawayDetailById(data) {
  return request({
    url: '/giveaway/fetchGiveawayDetailById',
    method: 'POST',
    data
  });
}
/* 赠品管理-赠品管理列表 */
export function queryGiveawayManagePageList(data) {
  return request({
    url: '/giveaway/manage/queryGiveawayManagePageList',
    method: 'POST',
    data
  });
}
/* 赠品管理-新增 */
export function saveGiveawayManage(data) {
  return request({
    url: '/giveaway/manage/saveGiveawayManage',
    method: 'POST',
    data
  });
}
/* 赠品管理-修改 */
export function updateGiveawayManage(data) {
  return request({
    url: '/giveaway/manage/updateGiveawayManage',
    method: 'POST',
    data
  });
}
/* 赠品管理-修改明细 */
export function fetchGiveawayManageDetailById(data) {
  return request({
    url: '/giveaway/manage/fetchGiveawayManageDetailById',
    method: 'POST',
    data
  });
}
/* 赠品管理-删除 */
export function removeGiveawayManageById(data) {
  return request({
    url: '/giveaway/manage/removeGiveawayManageById',
    method: 'POST',
    data
  });
}



// WEBPACK FOOTER //
// ./src/api/giftPromotion.js